import { MutableValue } from "@/modules/api/mutable-value.interface";

export default class ProductGroup implements MutableValue {
  public isNew = true;

  private fCreatedAt?: Date;
  private fUpdatedAt?: Date;

  constructor(
    private fId: string,
    private fPeriod: string,
    private fName: string,
    private fInternationalDueDate: Date | undefined,
    private fDomesticDueDate: Date | undefined,
    private fProducts: string[]
  ) {
    [fId, fPeriod, fName, fProducts].forEach((arg, index) => {
      if (arg === undefined) {
        throw new Error(`Undefined value passed at position: ${index}`);
      }
    });
  }

  get id(): string {
    return this.fId;
  }

  get period(): string {
    return this.fPeriod;
  }

  get name(): string {
    return this.fName;
  }

  set name(value: string) {
    this.fName = value;
  }

  get internationalDueDate(): Date | undefined {
    return this.fInternationalDueDate;
  }

  set internationalDueDate(value: Date | undefined) {
    this.fInternationalDueDate = value;
  }

  get domesticDueDate(): Date | undefined {
    return this.fDomesticDueDate;
  }

  set domesticDueDate(value: Date | undefined) {
    this.fDomesticDueDate = value;
  }

  get products(): string[] {
    return this.fProducts.slice();
  }

  set products(value: string[]) {
    this.fProducts = value.slice();
  }

  get createdAt(): Date | undefined {
    return this.fCreatedAt;
  }

  get updatedAt(): Date | undefined {
    return this.fUpdatedAt;
  }
}
